import PropTypes from "prop-types";
import React from "react";

// Styles
import "../styles/app.css";
import Footer from "components/Footer";
import CommonLayout from "components/CommanLayout";
import Header from "./Header";

/**
 * Main layout component
 *
 * The Layout component wraps around each page and template.
 * It also provides the header, footer as well as the main
 * styles, and meta data for each page.
 *
 */

const DefaultLayout = ({ children, ...props }) => {
    const { isHeadTransparent } = props;

    return (
        <CommonLayout>
            <div className="viewport">
                <div className="viewport-top">
                    {/* The main header section on top of the screen */}
                    <Header isHeadTransparent={isHeadTransparent} />
                    {/* All the main content gets inserted here, index.js, post.js */}
                    {children}
                </div>

                <Footer />
            </div>
        </CommonLayout>
    );
};

DefaultLayout.propTypes = {
    children: PropTypes.node.isRequired,
    bodyClass: PropTypes.string,
    isHeadTransparent: PropTypes.bool,
};

export default DefaultLayout;
